<template>
    <div class="home" v-if="application">
        <b-container fluid>
            <b-row>
                <b-col>
                    <h1>CNA Interstate Endorsement Application Review</h1>
                </b-col>
            </b-row>

            <div class="card">
                <div class="card-header">Application Review</div>
                <div class="card-body">
                    <b-row>
                        <b-col cols="4"><BaseTextOutput label="Current Assignee" :value="application.assignedName"/></b-col>
                        <b-col cols="4"><BaseTextOutput label="Assigned Date" :value="application.assignedDate"/></b-col>
                        <b-col cols="4" v-if="!isAssigned && !isReadonly"><b-button variant="success" class="mr-4" @click="reassign" :disabled="disableSelfassignButton">Assign To Me</b-button></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <BaseTextOutput label="Applicant's Name" :value="profile.fullName"/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="2">
                            <BaseTextOutput label="Application Status" :value="application.status.description"/>
                        </b-col>
                        <b-col cols="2">
                            <BaseTextOutput label="Submitted Date" :value="formatDateTime(application.submittedDate)"/>
                        </b-col>
                        <b-col cols="2">
                            <BaseTextOutput label="Approved Date" :value="formatDate(application.approvedDate)"/>
                        </b-col>
                        <b-col cols="2">
                            <BaseTextOutput label="Expiration Date" :value="formatDate(application.expirationDate)"/>
                        </b-col>
                    </b-row>
                    <b-row v-if="application.status.description==='Denied'">
                        <b-col>
                            <BaseTextOutput label="Denial Reason" :value="application.denialReason.code==='OTH'?application.otherDenialReason:application.denialReason.description"/>
                        </b-col>
                    </b-row>
                    <b-row class="mt-2">
                        <b-col cols="12">
                            <p class="mb-1">Internal MDH Notes</p>
                            <b-table hover small show-empty class="sr-caption"
                                     aria-live="polite"
                                     responsive="true"
                                     :fields="noteFieldsInternal"
                                     :items="notesInternal"
                                     :busy="false"
                                     label-sort-asc=""
                                     label-sort-desc=""
                                     caption="Notes table.  To sort the data in this table by a specific column,
                                go to the appropriate column header cell and use enter to sort the data ascending.
                                Use enter again to sort descending.">
                                <template v-slot:no-data>
                                    No Notes Found.
                                </template>
                                <div slot="table-busy" class="text-center text-danger my-2">
                                    <b-spinner class="align-middle" label="Loading, Please Wait" aria-label="Loading, Please Wait"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                                <template slot="empty" slot-scope="scope">
                                    No Notes Found.
                                </template>
                                <template v-slot:cell(note)="row">
                                    <div style="white-space: pre-line">{{row.item.note}}</div>
                                </template>
                                <template v-slot:cell(noteDate)="row">
                                    {{formatDateTime(row.item.noteDate)}}
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                    <b-row class="mt-2">
                        <b-col cols="12">
                            <p style="font-weight:750;" class="mb-1">Notes Sent to/from Applicant</p>
                            <b-table hover small show-empty class="sr-caption"
                                     aria-live="polite"
                                     responsive="true"
                                     :fields="noteFields"
                                     :items="notes"
                                     :busy="false"
                                     label-sort-asc=""
                                     label-sort-desc=""
                                     :tbody-tr-class="highLightUnread"
                                     caption="Notes sent to/from applicant table.  To sort the data in this table by a specific column,
                                go to the appropriate column header cell and use enter to sort the data ascending.
                                Use enter again to sort descending.">
                                <template v-slot:no-data>
                                    No Notes Found.
                                </template>
                                <template v-slot:cell(noteDate)="row">
                                    {{formatDateTime(row.item.noteDate)}}
                                </template>
                                <template v-slot:cell(note)="row">
                                    <div style="white-space: pre-line">{{row.item.note}}</div>
                                </template>
                                <div slot="table-busy" class="text-center text-danger my-2">
                                    <b-spinner class="align-middle" label="Loading, Please Wait" aria-label="Loading, Please Wait"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                                <template slot="empty" slot-scope="scope">
                                    No Notes Found.
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3" v-if="!isReadonly">
                        <b-col cols="6">
                            <BaseParagraphInput v-model="newNoteInternal"
                                                :v="$v.newNoteInternal"
                                                label="Internal Review Comments"
                                                slug="reviewComments"
                                                tip=""
                                                setId="reviewComments"
                            />
                            <b-button size="sm"
                                      variant="primary"
                                      class="mr-1"
                                      @click="showInternalNoteModal(newNoteInternal)"
                                      target="_attach"
                            >
                                Submit
                            </b-button>
                        </b-col>
                        <b-col cols="6">
                            <BaseParagraphInput v-model="newNote"
                                                :v="$v.newNote"
                                                label="Public Review Comments"
                                                slug="publicComments"
                                                tip="These comments WILL BE shared with the applicant."
                                                setId="publicComments"
                            />
                            <b-button size="sm"
                                      variant="primary"
                                      class="mr-1"
                                      @click="showExternalNoteModal(newNote)"
                                      target="_attach"
                            >
                                Submit
                            </b-button>
                        </b-col>
                    </b-row>
                  <b-row class="mt-2">
                    <b-col cols="12">
                      <p style="font-weight:750;" class="mb-1">System Note / Correction History</p>
                      <b-table hover small show-empty class="sr-caption"
                               aria-live="polite"
                               responsive="true"
                               :fields="systemNoteFields"
                               :items="systemNotes"
                               :busy="false"
                               label-sort-asc=""
                               label-sort-desc=""
                               :tbody-tr-class="highLightUnread"
                               caption="Notes created by system, generally during an application edit by applicant.  To sort the data in this table by a specific column,
                                go to the appropriate column header cell and use enter to sort the data ascending.
                                Use enter again to sort descending.">
                        <template v-slot:no-data>
                          No Notes Found.
                        </template>
                        <template v-slot:cell(noteDate)="row">
                          {{formatDateTime(row.item.noteDate)}}
                        </template>
                        <div slot="table-busy" class="text-center text-danger my-2">
                          <b-spinner class="align-middle" label="Loading, Please Wait" aria-label="Loading, Please Wait"></b-spinner>
                          <strong>Loading...</strong>
                        </div>
                        <template slot="empty" slot-scope="scope">
                          No Notes Found.
                        </template>
                      </b-table>
                    </b-col>
                  </b-row>
                    <b-row v-if="!isReadonly && isAssigned">
                        <b-col cols="12">
                            <b-dropdown text="Approval Decision" variant="primary" class="m-2" v-if="isActionable">
                                <b-dropdown-item-button @click="showApprovalModal">Approve Application</b-dropdown-item-button>
                                <b-dropdown-item-button @click="showDenyModal">Deny Application</b-dropdown-item-button>
                            </b-dropdown>
                        </b-col>
                    </b-row>
                    <b-row v-if="!isReadonly && isAssigned">
                        <b-col cols="12">
                            <b-button v-if="isActionable && application.status.description !=='Returned'" variant="primary" @click="showReturnModal" class="m-2">Return Application</b-button>
                        </b-col>
                      <b-col cols="12">
                          <b-button v-if="application.status.description === 'Returned'" variant="primary" @click="unreturnApplication" class="m-2" :disabled="disableCancelReturnButton">Cancel application return</b-button>
                      </b-col>
                    </b-row>
                  <b-row v-if="!isReadonly">
                    <b-col cols="12">
                      <b-button variant="primary" @click="showEditModal" class="m-2">Edit Application</b-button>
                    </b-col>
                  </b-row>
                </div>
            </div>
            <div class="card">
                <div class="card-header">Certification Information</div>
                <div class="card-body">
                    <b-row>
                        <b-col cols="12">
                            <p class="font-weight-normal">
                                Application for Certification as {{certificate.type.description}}.
                            </p>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="4"><BaseTextOutput label="State Certified" :value="endorsement.state ? opts.stateOptions.find(x=>x.value===endorsement.state).text : ''"/></b-col>
                        <b-col cols="4"><BaseTextOutput label="Certificate #" :value="endorsement.certificateNumber"/></b-col>
                        <b-col cols="4"><BaseTextOutput label="Has Worked in Last 24 Months" :value="endorsement.workPeriod?'Yes':'No'"/></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="4"><BaseTextOutput label="Has Tested in Last 24 Months" :value="endorsement.testPeriod?'Yes':'No'"/></b-col>
                        <b-col cols="4"><BaseTextOutput label="Date Tested in Endorsing State" :value="formatDate(endorsement.testDate)"/></b-col>
                    </b-row>
                </div>
            </div>
            <div class="card">
                <div class="card-header">Applicant Information</div>
                <div class="card-body">
                    <b-row>
                        <b-col cols="3">
                            <BaseTextOutput label="Last Name" :value="profile.lastName"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput label="First Name" :value="profile.firstName"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput label="Middle Name" :value="profile.middleName"/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="3">
                            <BaseTextOutput label="Street Address" :value="profile.contact.address.streetAddress"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput label="City" :value="profile.contact.address.city"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput label="State" :value="opts.stateOptions.find(x=>x.value===profile.contact.address.state).text"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput label="Zip" :value="profile.contact.address.postalCode"/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="3">
                            <BaseTextOutput label="Cell Phone Number" :value="profile.contact.phone"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput label="Email Address" :value="profile.contact.email"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput label="Date Of Birth" :value="formatDate(profile.dateOfBirth)"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput label="Social Security Number" :value="profile.ssn"/>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <div class="card">
                <div class="card-header">Application Attachments</div>
                <div class="card-body">
                    <b-row>
                        <AdminAttachmentList :items="application.attachments" :isReadonly="isReadonly" @attachment-delete-success="handleDelete" @attachment-delete-failure="showDeleteFailToast"/>
                    </b-row>
                    <b-row>
                        <FileAttachmentSupplemental v-on:attachment-added="handleUploadSuccess" v-on:attachment-failed="handleUploadFailure"
                                                    :appId="application.id" :attachmentTypeOptions="attachmentTypeOptions"
                                                    describedBy="intAttachmentsDesc"/>
                    </b-row>
                </div>
            </div>
            <div class="card">
                <div class="card-header">Facility</div>
                <div class="card-body">
                    <div v-for="employer in application.employers" :key="employer.id">
                        <b-row>
                            <b-col cols="3">
                                <BaseTextOutput label="Facility Name" :value="employer.name"/>
                            </b-col>
                            <b-col cols="3">
                                <BaseTextOutput label="Staffing Agency" :value="employer.staffingAgency?'Yes':'No'"/>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="3">
                                <BaseTextOutput label="Street Address" :value="employer.address.streetAddress"/>
                            </b-col>
                            <b-col cols="3">
                                <BaseTextOutput label="City" :value="employer.address.city"/>
                            </b-col>
                            <b-col cols="3">
                                <BaseTextOutput label="State" :value="employer.address.state"/>
                            </b-col>
                            <b-col cols="3">
                                <BaseTextOutput label="Zip Code" :value="employer.address.postalCode"/>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </b-container>
        <b-modal id="external-note-modal" hide-header hide-footer>
            <h2>Add external note</h2>
            <hr/>
            <form ref="form" @submit.prevent="attachNewExternalNote">
                You are about to attach a new public note to the interstate endorsement {{certificate.type.description}} application from user {{profile.fullName}}.
                <br/>
                These notes will be shared with and visible to the applicant.
                <p class="mt-2">Press Confirm to attach this note or Cancel to return to the application review.</p>
                <div>
                    <b-button @click="closeExternalNoteModal" style="margin-right:15px;" variant="secondary">Cancel</b-button>
                    <b-button type="submit" variant="primary">Confirm</b-button>
                </div>
            </form>
        </b-modal>
        <b-modal id="internal-note-modal" hide-header hide-footer>
            <h2>Add internal note</h2>
            <hr/>
            <form ref="form" @submit.prevent="attachNewInternalNote">
                You are about to attach a new internal note to the interstate endorsement {{certificate.type.description}} application from user {{profile.fullName}}.
                <br/>
                These notes will be not shared with or visible to the applicant.
                <p class="mt-2">Press Confirm to attach this note or Cancel to return to the application review.</p>
                <div>
                    <b-button @click="closeInternalNoteModal" style="margin-right:15px;" variant="secondary">Cancel</b-button>
                    <b-button type="submit" variant="primary">Confirm</b-button>
                </div>
            </form>
        </b-modal>
        <b-modal id="approval-modal" hide-header hide-footer>
            <h2>Approve Application</h2>
            <hr/>
            <form ref="form" @submit.prevent="approve">
                You are about to <strong>approve</strong> the interstate endorsement {{certificate.type.description}} application from user {{profile.fullName}}.
                <BaseSelector v-model="processReason"
                              :v="$v.processReason"
                              label="Process Reasons"
                              :options="processReasons"
                              setId="processReasons"
                              />
                <BaseDateOfBirthInput v-model="newExpirationDate"
                                      :v="$v.newExpirationDate"
                                      label="New expiration date for this certificate"
                                      setId="processReasons"
                                      tip="Format: MM/DD/YYYY"
                />
                <BaseSelector v-model="substantiatedComplaints"
                              :v="$v.substantiatedComplaints"
                              label="Substantiated complaints?"
                              :options="opts.yesNoBoolOptions"
                              setId="substantiatedComplaints"
                              tip="Does this endorsement applicant have substantiated complaints from the state they're seeking endorsement from?"/>
                <div v-if="!isValidApproval">
                    <p class="mt-2 text-danger" v-if="this.processReason==='ACTIVE'">For Processed and Active the new expiration date must be in the future.</p>
                    <p class="mt-2 text-danger" v-if="this.processReason==='INACTIVE'">For Processed but Inactive the new expiration date must be in the past.</p>
                </div>
                <p class="mt-2">Press Confirm to approve this application with this expiration date or Cancel to return to the application review.</p>
                <div>
                    <b-button @click="closeApprovalModal" style="margin-right:15px;" variant="secondary">Cancel</b-button>
                    <b-button type="submit" variant="primary" v-if="isValidApproval">Confirm</b-button>
                </div>
            </form>
        </b-modal>
        <b-modal id="deny-modal" hide-header hide-footer>
            <h2>Deny Application</h2>
            <hr/>
            <form ref="form" @submit.prevent="deny">
                You are about to <strong>deny</strong> the interstate endorsement {{certificate.type.description}} application from user {{profile.fullName}}.
                <BaseSelector v-model="denialReason"
                              :v="$v.denialReason"
                              label="Denial Reasons"
                              slug="denialReason"
                              :options="denialReasons"
                              setId="denialReason"
                />
                <BaseParagraphInput v-if="denialReason==='OTH'" v-model="otherDenialReason"
                                    :v="$v.otherDenialReason"
                                    label="Other denial reason"
                                    slug="otherDenialReason"
                                    tip=""
                                    setId="otherDenialReason"
                />

                <p class="mt-2">Press Confirm to deny this application or Cancel to return to the application review.</p>
                <div>
                    <b-button @click="closeDenyModal" style="margin-right:15px;" variant="secondary">Cancel</b-button>
                    <b-button type="submit" variant="primary">Confirm</b-button>
                </div>
            </form>
        </b-modal>
        <b-modal id="return-modal" hide-header hide-footer>
            <h2>Open application return page?</h2>
            <div>This will give you an opportunity to mark issues on this application and return it to the Interstate Endorsement Applicant for corrections.</div>
            <div>Click <strong>Continue</strong> to proceed to application return page or <strong>Cancel</strong> to return to application review.</div>
            <b-button :href="'/return-endorsement/'+application.id" variant="primary" class="m-2">Continue</b-button>
            <b-button @click="closeReturnModal" variant="secondary">Cancel</b-button>
        </b-modal>
      <b-modal id="edit-modal" hide-header hide-footer>
        <h2>Open application edit page?</h2>
        <div>This will give you an opportunity to edit the application and save the edits.</div>
        <div>Click <strong>Continue</strong> to proceed to application edit page or <strong>Cancel</strong> to return to application review.</div>
        <b-button :href="'/edit-endorsement/'+application.id" variant="primary" class="m-2">Continue</b-button>
        <b-button @click="closeEditModal" variant="secondary">Cancel</b-button>
      </b-modal>
    </div>
</template>

<script>
    import BaseTextOutput from "@/components/templates/input/BaseTextOutput";
    import BaseParagraphInput from "@/components/templates/input/BaseParagraphInput";
    import axios from 'axios';
    import {required, requiredIf, minLength, maxLength} from 'vuelidate/lib/validators'
    import FileAttachmentSupplemental from "@/components/templates/input/FileAttachmentSupplemental";
    import BaseSelector from "@/components/templates/input/BaseSelector";
    import moment from 'moment';
    import BaseDateOfBirthInput from "@/components/templates/input/BaseDateOfBirthInput";
    import {toastService} from "@/mixins/toastService";
    import {commonOptions} from "@/mixins/commonOptions";
    import AdminAttachmentList from "@/components/templates/AdminAttachmentList";

    export default {
        name: "EndorsementReview",
        components:{
            BaseTextOutput,
            BaseParagraphInput,
            FileAttachmentSupplemental,
            BaseSelector,
            BaseDateOfBirthInput,
            AdminAttachmentList
        },
        mixins: [
            toastService,
            commonOptions
        ],
        data:()=>({
            application: null,
            profile: null,
            certificate: null,
            endorsement: null,
            notes: [],
            notesInternal: [],
          systemNotes: [],
            noteFields: [
                {key: 'note', label: 'Note',sortable:true},
                {key: 'noteType.description',label:'Note Type', sortable:true},
                {key: 'noteDate',label:'Note Date',sortable:true},
                {key:'noteByName',sortable:true,label:'Note By'},
                {key:'noteRead.description',sortable:true,label:'Note Read?'}
            ],
            noteFieldsInternal: [
                {key: 'note', label: 'Note',sortable:true},
                {key: 'noteType.description',label:'Note Type', sortable:true},
                {key: 'noteDate',label:'Note Date',sortable:true},
                {key:'noteByName',sortable:true,label:'Note By'},
            ],
          systemNoteFields: [
            {key: 'note',label: 'Note',sortable:true},
            {key: 'noteDate', label: 'Note Date',sortable:true}
          ],
            newNote: '',
            newNoteInternal: '',
            attachmentTypeOptions: [],
            denialReasons: [],
            denialReason: null,
            otherDenialReason: '',
            processReasons: [],
            processReason: null,
            processOtherReason: null,
            newExpirationDate: null,
            substantiatedComplaints: false,
            disableSelfassignButton: false,
            disableCancelReturnButton: false,
        }),
        created(){
            this.loadApplication();
            this.loadAttachmentTypes();
            this.loadDenialReasons();
            this.loadProcessReasons();
            this.loadExternalNotes();
            this.loadInternalNotes();
            setTimeout(this.markNotesAsRead,5000)
        },
        methods:{
            loadApplication(){
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/application/renewal/${this.$route.params.id}`)
                    .then(response=>{
                        this.application = response.data.application;
                        this.profile = response.data.profile;
                        this.certificate = response.data.certificate;
                        this.endorsement = response.data.endorsement;
                        // this.notesInternal = this.application.internal.filter(n=>n.noteBy!=null);
                        // this.notes = this.application.external;
                        this.systemNotes = this.application.internal.filter(n=>n.noteBy==null);
                    })
            },
            loadInternalNotes(){
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/application/notesInternal/${this.$route.params.id}`)
                    .then(response=>{
                        this.notesInternal = response.data;
                    })
            },
            loadExternalNotes(){
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/application/notes/${this.$route.params.id}`)
                    .then(response=>{
                        this.notes=response.data;
                    })
            },
            loadAttachmentTypes(){
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/attachments/internal/mdhSupplementalTypes`)
                    .then(response=>{
                        for(let type of response.data){
                            this.attachmentTypeOptions.push({
                                value: type.code,
                                text: type.description
                            })
                        }
                    })
            },
            loadDenialReasons(){
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/approval/denialReasons`)
                    .then(response=>{
                        for(let reason of response.data){
                            this.denialReasons.push({
                                value: reason.code,
                                text: reason.description
                            })
                        }
                    })
            },
            loadProcessReasons(){
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/approval/processReasons`)
                    .then(response=>{
                        for(let reason of response.data){
                            this.processReasons.push({
                                value: reason.code,
                                text: reason.description
                            })
                        }
                    })
            },
            markNotesAsRead(){
              if(this.$keycloak.authenticated && !this.$keycloak.hasResourceRole('readonly')) {
                axios.put(`${process.env.VUE_APP_API_BASE_URL}/application/notes/${this.$route.params.id}/readMdh`);
              }
            },
          showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
              title: title,
              toaster: 'b-toaster-top-center',
              solid: true,
              variant: type,
              appendToast: true,
              noAutoHide:true
            })
            this.toastFocus()
          },
          toastFocus() {
            setTimeout(() => {
              let elem = document.getElementsByClassName("toast")
              elem = elem[elem.length-1]
              elem.focus()
            }, 100)
          },
            approve(){
                this.$v.$touch();
                if(this.$v.$invalid){
                    return;
                }
                axios.post(`${process.env.VUE_APP_API_BASE_URL}/approval/interstate/approve/${this.$route.params.id}/${this.substantiatedComplaints}`, this.newExpirationDate)
                    .then(response => {
                        this.showRootToast('Application approved', 'The application has been successfully approved','success', this.$root);
                        this.loadApplication();
                    })
                    .catch(error=>{
                        this.showRootToast('Error', 'Approval failed','danger', this.$root)
                    })
                    .finally(()=>{
                        this.closeApprovalModal();
                        this.newExpirationDate=null;
                    })
            },
            deny(){
                axios.post(`${process.env.VUE_APP_API_BASE_URL}/approval/interstate/deny/${this.$route.params.id}`,
                    {
                        denialReason: this.denialReason,
                        otherDenialReason: this.otherDenialReason
                    })
                    .then(response => {
                        this.showRootToast('Application denied', 'The application has been successfully denied','success', this.$root);
                        this.loadApplication();
                    })
                    .catch(error=>{
                        this.showRootToast('Error', 'Denial failed','danger', this.$root);
                    })
                    .finally(()=>{
                        this.closeDenyModal();
                        this.otherDenialReason = null;
                        this.denialReason = null;
                    })
            },

            showApprovalModal(){
                this.$bvModal.show('approval-modal');
                this.$nextTick(()=>{
                    let date = moment();
                    date.add(2, 'y');
                    date.subtract(1, 'd');
                    this.newExpirationDate = date.format('YYYY-MM-DD');})
            },
            closeApprovalModal(){
                this.$bvModal.hide('approval-modal');
            },
            showDenyModal(){
                this.$bvModal.show('deny-modal');
            },
            closeDenyModal(){
                this.$bvModal.hide('deny-modal');
            },
            showReturnModal(){
                this.$bvModal.show('return-modal');
            },
            showEditModal(){
              this.$bvModal.show('edit-modal');
            },
            closeEditModal(){
              this.$bvModal.hide('edit-modal');
            },
            closeReturnModal(){
                this.$bvModal.hide('return-modal');
            },
            showExternalNoteModal(){
                this.$bvModal.show('external-note-modal');
            },
            showInternalNoteModal(){
                this.$bvModal.show('internal-note-modal');
            },
            closeExternalNoteModal(){
                this.$bvModal.hide('external-note-modal')
            },
            closeInternalNoteModal(){
                this.$bvModal.hide('internal-note-modal');
            },
            attachNewExternalNote(){
                axios.post(`${process.env.VUE_APP_API_BASE_URL}/application/notes/${this.$route.params.id}/addFromMDH`,this.newNote)
                    .then(response => {
                        this.showRootToast('External note attached', 'The external note has been successfully attached to this application','success', this.$root);
                        this.newNote='';
                        this.loadExternalNotes();
                    })
                    .catch(error=>{
                        this.showRootToast('Error', 'Attaching the external note failed','danger', this.$root)
                    })
                    .finally(()=>{
                        this.closeExternalNoteModal();
                    })
            },
            attachNewInternalNote(){
                axios.post(`${process.env.VUE_APP_API_BASE_URL}/application/notesInternal/${this.$route.params.id}/add`,this.newNoteInternal)
                    .then(response => {
                        this.showRootToast('Internal note submitted.', 'The internal note has been successfully attached to this application','success', this.$root)
                        this.newNoteInternal='';
                        this.loadInternalNotes();
                    })
                    .catch(error=>{
                        this.showRootToast('Error', 'Attaching the internal note failed','danger', this.$root)
                    })
                    .finally(()=>{
                        this.closeInternalNoteModal();
                    })
            },
            reloadAttachments(){
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/attachments/get/${this.$route.params.id}`)
                    .then(response=>{
                        this.application.attachments = response.data
                    })
            },
            highLightUnread(item,type){
                return (item != null && item.noteType.code==='EXTIN' && item.noteRead.code==="UNREAD")?'table-warning':'';
            },
            handleUploadSuccess() {
                this.showRootToast('File Attached', 'The file has been successfully attached to this application', 'success', this.$root);
                this.reloadAttachments();
            },
            handleUploadFailure(){
                this.showRootToast('Upload Failed', 'File Upload Failed','danger', this.$root);
            },
            formatDate(unformattedDate){
                let formattedDate = moment(unformattedDate);
                if(!formattedDate.isValid()) return '';
                return formattedDate.format("MM/DD/YYYY")
            },
            formatDateTime(noteDateTime){
                return moment(noteDateTime).format('MM/DD/YYYY hh:mmA');
            },
            reassign() {
                this.disableSelfassignButton = true;
                let payload = {
                    id: this.application.id,
                    assignedName: this.$keycloak.subject,
                    type: this.application.assignType.code
                }
                    axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/assign`, payload)
                        .then(response => {
                            this.loadApplication()
                            this.showRootToast("Assigned", "Credentialer has been assigned.", "success", this.$root)
                        }) .catch(error => {
                      this.showRootToast("Error", "An error has occurred ", "danger", this.$root)
                      this.disableSelfassignButton = false;
                    });
            },
          handleDelete(){
            this.showRootToast('Deleted', 'The attachment was successfully deleted','success',this.$root);
            this.reloadAttachments();
          },
          showDeleteFailToast(){
            this.showRootToast('Delete failure', 'The attachment failed to delete', 'danger', this.$root);
          },
          unreturnApplication(){
              this.disableCancelReturnButton = true;
              axios.post(`${process.env.VUE_APP_API_BASE_URL}/approval/unreject/${this.$route.params.id}`)
                  .then(response => {
                    this.showRootToast('Return canceled', 'Application has been returned back to received status', 'success')
                    this.$nextTick(()=>{
                      this.loadApplication();
                    });
                  })
                  .catch(error => {
                    this.showRootToast('Return cancel failed', '', 'danger');
                    this.disableCancelReturnButton = false;
                  })

          }
        },
        validations: {
            newNote: { required: false,  maxLength: maxLength(4000)},
            newNoteInternal: {required: false, maxLength: maxLength(4000)},
            denialReason: {required: true},
            otherDenialReason: {
                required: requiredIf(function(){
                    return this.denialReason === 'OTH';
                }),
                minLength: minLength(1)
            },
            processReason:{required: true},
            newExpirationDate: {
                required: true
            },
            substantiatedComplaints: {required: true}
        },
        computed: {
            isActionable: function () {
                let statuses = ["Received", "In Progress", "Reopened", "Resubmitted", "Returned"];
                return statuses.some(s => s === this.application.status.description)
            },
            isReadonly() {
                return this.$keycloak.authenticated && (this.$keycloak.hasResourceRole('readonly'))
            },
            isAssigned() {
                return this.$keycloak.authenticated && this.$keycloak.subject === this.application.assigned
            },
            isValidApproval: function () {
                return (this.processReason === "ACTIVE" && moment(this.newExpirationDate).isSameOrAfter(moment().subtract(1, 'd'))) || (this.processReason === "INACTIVE" && moment(this.newExpirationDate).isBefore(moment().subtract(1, 'd')))
            },
        }

    }
</script>

<style scoped>
p {
    font-weight: 700;
}

</style>